export default class OP3Dashboard {
    constructor() {
        // All links leading to docs.optimizepress.com are opened in a new tab
        jQuery(function($) {
            let domains = [
                    'docs.optimizepress.com',
                    'my.optimizepress.com',
                    'www.optimizelink.com',
                    'optimizelink.com',
                ],
                selector = domains.map(domain => `a[href*="//${domain}"]`).join(',');

            $(selector).attr('target', '_blank');
        });
    }
}
